import { render } from "./ThemeColor.vue?vue&type=template&id=12bbd90e"
import script from "./ThemeColor.vue?vue&type=script&lang=ts"
export * from "./ThemeColor.vue?vue&type=script&lang=ts"
script.render = render

export default script